export default __webpack_public_path__ + "static/media/tamara-bellis-8Aq_zfMHPbU-unsplash.2bcc31fb.jpg";